module.exports = __webpack_public_path__ + "img/bullet-check.3c073046.svg";